import React from 'react'

import _ from 'lodash';
import dayjs from 'dayjs';

export const isTrue = (maybeTrue) => {
	return (maybeTrue === 1 || maybeTrue === true || maybeTrue === '1');
}

export const maybeWithPrefix = (prefix, val, strong = false) => {
	return (prefix && prefix !== val) ? 
		(strong ? <><strong>{prefix}</strong>: {val}</> : prefix + ': ' + val) : 
		val;
}

export const indefiniteArticle = (singularWord, capitalise = false) => {
	if(_.isEmpty(singularWord) || !_.isString(singularWord)){
		return singularWord;
	}
	const vowels = ['a', 'e', 'i', 'o', 'u'];
	const withArticle = vowels.includes(singularWord[0]) ? 'an ' + singularWord : 'a ' + singularWord;
	return capitalise ? _.capitalize(withArticle) : withArticle;
}

export const untrailingSlashIt = (path) => {
	return _.trimEnd(path, '/');
}

export const includesSubscription = (cart) => {
	return _.some(cart, {subscription: 1}) || _.some(cart, {subscription: true})
}
	
export const landlineMask = string => {
	
	const digits = string.replace(/[^0-9]/g, '').substring(0,10);
	
	if(_.isEmpty(digits)){
		return '';
	}
	
	const l1 = digits.slice(0,2).padEnd(2, '_');
	const l2 = digits.slice(2,6).padEnd(4, '_');
	const l3 = digits.slice(6,10).padEnd(4, '_');
	return `(${l1}) ${l2}-${l3}`

}

export const mobileMask = string => {
	const digits = string.replace(/[^0-9]/g, '').substring(0,10);
	
	if(_.isEmpty(digits)){
		return '';
	}
	
	const m1 = digits.slice(0,4).padEnd(4, '_');
	const m2 = digits.slice(4,7).padEnd(3, '_');
	const m3 = digits.slice(7,10).padEnd(3,'_');
	return `${m1} ${m2} ${m3}`
}

export const daysSorter = {
	Mon: 0,
	Tue: 1,
	Wed: 2,
	Thu: 3,
	Fri: 4,
	Sat: 5,
	Sun: 6
}

export const describeDate = date => {
	return dayjs(date).format('D MMM YYYY');
}

export const describeTime = time => {
	return dayjs('2020-01-01 '+time).format('h:mm A');
}

export const isFinished = date => {
	return dayjs(date).isBefore();
}
	
export const fixedOptions = option => {
	switch(option){
		case 'states':
			return {
				'ACT': 'ACT', 
				'NSW': 'NSW', 
				'NT': 'NT', 
				'QLD': 'QLD', 
				'SA': 'SA', 
				'TAS': 'TAS', 
				'VIC': 'VIC', 
				'WA': 'WA'
			}
		case 'genders':
			return {
				M: 'Male',
				F: 'Female',
				O: 'Other'
			}
		case 'days':
			return  {
				Mon: "Monday",
				Tue: "Tuesday",
				Wed: "Wednesday",
				Thu: "Thursday",
				Fri: "Friday",
				Sat: "Saturday",
				Sun: "Sunday"
			}
		default:
			return {}
	}
}

export const formatMemberAddress = member => {
	return _.chain([
		member.address1.trim(), 
		member.street.trim(), 
		member.suburb.trim(), 
		(member.state.toUpperCase() + ' ' + member.postcode).trim()
		]).without('').join('\n').value();
}